<template>
  <div id="name" class="container">
    <Question :question="question">
      <div class="form-group">
        <div class="input-group">
            <div class="input-group-prepend">
                <span class="input-group-text">Branch of Service</span>
            </div>
            <select class="form-control" v-model="bos" required>
                <option value="" selected disabled hidden>Choose here</option>
                <option value="army">Army</option>
                <option value="air force">Air Force</option>
                <option value="navy">Navy</option>
                <option value="marines">Marines</option>
                <option value="coast guard">Coast Guard</option>
                <option value="army national guard">Army National Guard</option>
                <option value="air force national guard">Air Force National Guard</option>                                                                                        
                <option value="army reserve">Army Reserve</option>
                <option value="air force reserve">Air Force Reserve</option>
                <option value="marine reserve">Marine Reserve</option>
                <option value="coast guard reserve">Coast Guard Reserve</option>                                                                            
                <option value="other">Other</option>  
            </select>
        </div>
        <br>
        <DateInput label="Start Date" v-model="startDate"/>
        <br>
        <DateInput label="End Date" v-model="endDate"/>                    
        <br>
        <div class="input-group">
            <div class="input-group-prepend">
                <span class="input-group-text">Discharge Type</span>
            </div>
            <select class="form-control" v-model="dischargeType" required>
                <option value="" selected disabled hidden>Choose here</option>                
                <option value="honorable">Honorable</option>
                <option value="general">General</option>
                <option value="dishonorable">Dishonorable</option>
                <option value="OTH">OTH</option>
                <option value="bad conduct">Bad Conduct</option>
                <option value="none">None</option>                                                                        
            </select>
        </div>
        <br>
        <br>
        <br>
        <div class="input-group">
            <textarea class="form-control" v-model="notes" placeholder="Notes"></textarea>            
        </div>
        <br>
      </div>
      <p class="text-center">Please fill out as much as you can.</p>
    </Question>
  </div>
</template>

<script>
import Question from "../Question.vue";
import DateInput from './DateInput.vue'

export default {
  name: "Service",
  components: {
    Question,
    DateInput
  },
  props: {
      question: String
  },
  data(){
    return {
      bos: "",
      startDate: "",
      endDate: "",
      dischargeType: "",
      notes: "",
      officer: false,
      combatService: false,
      warTimeService: false
    }
  }
};
</script>